import React, { useRef, useEffect, useContext } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { LocalizationContext } from 'app/localization/Context';

export const FullPageTransitionTime = 650;

function AnimationContainer({ disable, inverse, children, height }) {
    const l = useContext(LocalizationContext);
    const variantsRTL = {
        initial: {
            translateX: "-100%"
        },
        animate: {
            translateX: "0%"
        },
        exit: {
            translateX: "100%"
        }
    }
    const variantsLTR = {
        initial: {
            translateX: "100%"
        },
        animate: {
            translateX: "0%"
        },
        exit: {
            translateX: "-100%"
        }
    }

    return (
        <motion.div
            initial={disable ? false : "initial"}
            animate="animate"
            exit="exit"
            variants={(l.isRTL !== inverse) ? variantsRTL : variantsLTR}
            transition={{
                ease: "easeInOut",
                duration: FullPageTransitionTime / 1000,
            }}

            style={{
                position: "absolute",
                top: 0,
                width: "100%",
                height: height,
            }}
        >
            {children}
        </motion.div>
    );
}

function FullPageTransition({ inverse, children, disableOnFirstTime, height }) {
    const notFirstTime = useRef();
    const _inverse = inverse === true;
    const _height = height ? height : "100%";

    let elems = [];
    for (let i = 0; i < children.length; i++) {
        const child = children[i];
        if (child.props.isVisible)
            elems.push(
                <AnimationContainer
                    inverse={_inverse} height={_height}
                    disable={disableOnFirstTime && !notFirstTime.current}
                    isVisible={child.props.isVisible} key={"anim-" + child.key}
                    name={"anim-" + child.key}>
                    {child}
                </AnimationContainer>
            )
    }

    useEffect(() => {
        notFirstTime.current = true;
    }, [children]);

    return (
        <AnimatePresence>
            {elems}
        </AnimatePresence>
    )
}

export default FullPageTransition;
